import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "Theme/Container";
import PlatformImage from "Theme/PlatformImage";
import SubTitle from "Theme/SubTitle";
import Title from "Theme/Title";
import Stepper from "Theme/Stepper";
import axios from "axios";
import Spinner from "Theme/Spinner";
import Error from "Theme/Error";

const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .post("/proxy.php", {
        token: location.pathname,
      })
      .then(({ data }) => {
        setLoading(false);
        if (data.data &&  data.data.number) {
          setOrder(data.data);
        } else {
          setError(true);
        }
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  }, [location]);
  return (
    <Container>
      {loading && <Spinner />}

      {order && (
        <>
          <Title>Konfigurator NTT</Title>
          <SubTitle>Numer zamówienia: {order.number}</SubTitle>

          <PlatformImage src={order.image} />

          <Stepper step={order.step} order={order} />
        </>
      )}

      {error && <Error />}
    </Container>
  );
};
export default App;
